export type NavIconName =
  | "access"
  | "operations"
  | "communities"
  | "communications"
  | "contact"
  | "reservations"
  | "payments"
  | "users"
  | "visitors"
  | "assemblies"
  | "notifications"
  | "subscription"
  | "ledger"
  | "more";

export type NavItem = {
  to: string;
  label: string;
  shortLabel?: string;
  icon: NavIconName;
  end?: boolean;
};

export type RoleNav = {
  primary: NavItem[];
  more: NavItem[];
};

export function navForRole(role: string): RoleNav {
  switch (role) {
    case "resident":
      return {
        primary: [
          { to: "/", label: "Acceso", icon: "access", end: true },
          { to: "/asambleas", label: "Asambleas", icon: "assemblies" },
          { to: "/comunicaciones", label: "Comunicaciones", shortLabel: "Comunic.", icon: "communications" },
          { to: "/reservas", label: "Reservas", icon: "reservations" },
          { to: "/pagos", label: "Pagos", icon: "payments" },
          { to: "/cuentas", label: "Ingresos y gastos", shortLabel: "Cuentas", icon: "ledger" },
        ],
        more: [],
      };
    case "frequent_visitor":
      return {
        primary: [{ to: "/", label: "Acceso", icon: "access", end: true }],
        more: [],
      };
    case "admin":
      return {
        primary: [
          { to: "/admin", label: "Operaciones", icon: "operations", end: true },
          { to: "/admin/usuarios", label: "Usuarios", icon: "users" },
          { to: "/admin/visitantes", label: "Visitantes", icon: "visitors" },
          { to: "/admin/pagos", label: "Pagos", icon: "payments" },
        ],
        more: [
          { to: "/admin/asambleas", label: "Asambleas", icon: "assemblies" },
          { to: "/admin/comunicaciones", label: "Comunicaciones", icon: "communications" },
          { to: "/admin/cuentas", label: "Ingresos y gastos", icon: "ledger" },
          { to: "/admin/reservas", label: "Reservas", icon: "reservations" },
          { to: "/admin/suscripcion", label: "Suscripción", icon: "subscription" },
        ],
      };
    case "platform_admin":
      return {
        primary: [
          { to: "/platform", label: "Comunidades", icon: "communities", end: true },
          { to: "/platform/facturacion", label: "Facturación", icon: "payments" },
          { to: "/platform/contacto", label: "Contacto", icon: "contact" },
        ],
        more: [],
      };
    case "billing_contact":
      return {
        primary: [{ to: "/platform/facturacion", label: "Facturación", icon: "payments", end: true }],
        more: [],
      };
    default:
      return { primary: [], more: [] };
  }
}

export function allNavItems(nav: RoleNav): NavItem[] {
  return [...nav.primary, ...nav.more];
}

export function navItemMatches(pathname: string, item: NavItem): boolean {
  if (item.end) return pathname === item.to;
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
}

export function moreNavIsActive(pathname: string, more: NavItem[]): boolean {
  return more.some((item) => navItemMatches(pathname, item));
}
